require("!!/builds/sitech/sitech_srm-client/node_modules/script-loader/addScript.js")(require("!!/builds/sitech/sitech_srm-client/node_modules/raw-loader/index.js!/builds/sitech/sitech_srm-client/node_modules/chart.js/dist/Chart.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/chart.js/dist/Chart.js
// module id = 201
// module chunks = 3